import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TestsuiteService {

  constructor(private http: HttpClient) { }

  getTestsuiteById(id: number) {
    return this.http.get<any>(environment.apiUrl + 'testSuites/' + id);
  }

  getTestSuiteList(searchParams) {
    return this.http.post<any>(environment.apiUrl + 'testSuites/list', searchParams);
  }

  getTestSuiteDetails(id) {
    return this.http.get<any>(environment.apiUrl + 'testSuites/' + id);
  }

  getTestCaseList(id) {
    return this.http.get<any>(environment.apiUrl + 'testSuites/' + id + '/testSuiteTestCases');
  }

  getEndPointList(id) {
    return this.http.get<any>(environment.apiUrl + 'testCases/' + id + '/testCaseEndPoints/shortData');
  }

  addTestSuite(params: any) {
    return this.http.post<any>(environment.apiUrl + 'testSuites', params);
  }

  getTestSuiteTestCases(id) {
    return this.http.get<any>(environment.apiUrl + 'testSuites/' + id + '/testSuiteTestCases');
  }

  associateDisassociateTestCases(id, params: any) {
    return this.http.post<any>(environment.apiUrl + 'testSuites/' + id + '/associateDisassociateTestCases', params);
  }

  updateTestSuitesCases(param) {
    return this.http.put<any>(environment.apiUrl + 'testSuites', param);
  }

  getEnv(projectId) {
    return this.http.get<any>(environment.apiUrl + 'environmentMaps/projects/' + projectId);
  }

  getTestSuiteResultByExecutionId(noSqlId) {
    return this.http.get<any>(environment.apiUrl + 'result/testSuite/execution/noSqlId/' + noSqlId);
  }

  executionStart(testSuiteId, environmentMapperId, params) {
    return this.http.post<any>(environment.apiUrl + 'executors/testSuites/' + testSuiteId + '/environmentMappers/' + environmentMapperId, params);
  }

  getMostRecentExec(id) {
    return this.http.get<any>(environment.apiUrl + 'result/testSuite/sqlId/' + id + '/lastExecution');
  }

  getAssociatedMastersuites(mastersuiteId: number, params: any) {
    return this.http.post<any>(environment.apiUrl + 'testSuites/' + mastersuiteId + '/masterSuites', params);
  }

  getResultTCase(noSqlId: string, pageNo: number, size: number): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'result/testCases/noSqlId/' + noSqlId + '/pages/' + pageNo + '/size/' + size);
  }

  getResultTCaseWithFilter(noSqlId: string, pageNo: number, size: number, testCaseStatus: string): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'result/testCases/noSqlId/' + noSqlId + '/pages/' + pageNo + '/size/' + size + '/executionstatus' + '?status=' + testCaseStatus);
  }

  readTestcasesFromNoSql(noSqlId): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'result/testSuite/' + noSqlId + '/testCaseShortData');
  }

  getSavedConfig(id) {
    return this.http.get<any>(environment.apiUrl + 'testSuites/' + id + '/fetchTestSuiteCodeCoverageDetails');
  }

  generateCodeCoverage(testSuiteId, userId, formData) {
    return this.http.post<any>(environment.apiUrl + 'testSuites/' + testSuiteId + '/generateAndCaptureTestSuiteCodeCoverageMetrics/' + userId,formData);
  }

  getPreviousResults(id) {
    return this.http.get<any>(environment.apiUrl + 'testSuites/' + id + '/fetchTestSuiteCodeCoverageMetrics');
  }

  saveConfig(testsuiteId, userId, formData) {
    return this.http.post<any>(environment.apiUrl + 'testSuites/' + testsuiteId + '/saveTestSuiteCodeCoverageConfig/' + userId, formData);
  }

  downloadCodeCoverage(testsuiteId, userId, formData) {
    return this.http.post<any>(environment.apiUrl + 'testSuites/' + testsuiteId + '/downloadTestSuiteCodeCoverage/' + userId,formData);
  }

  resumeCurrentExecService(executionId: string): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}executors/resume/testsuite/executions/${executionId}`, null);
  }

  deleteMultipleTestsuites(entityType: string, entityIdList: number[]): Observable<any> {
    const options = {
      body: {
        entityType,
        entityIdList
      }
    };
    return this.http.delete<any>(`${environment.apiUrl}testSuites/bulkDelete`, options);
  }
}
